module.exports = __webpack_public_path__ + "images/pin-bg@2x-e509a08d31f0033f8761856f5f9ab5d6.png";